import React from "react"
import Cabecalho from "../Cabecalho"
import { MarketingAutomaticoComponent } from "./components/MarketingAutomaticoComponent"

export function MarketingAutomatico() {
    return (
        <>
            <Cabecalho pagina="Marketing Automatizado" />
            <MarketingAutomaticoComponent />
        </>
    )
}
